
import { Test, TestPrimitive } from "../../views/landing"
import __matchings from "../../assets/img/matchings.svg" 

export const landingComponent = () : any => {  
    return {
        test: { 
            c: Test,  
            icon: __matchings, 
            title: "Single test", 
            interface: "IPETest",
            primitive: TestPrimitive 
        }
    }
}